import api from './api';
import { trackPromise } from 'react-promise-tracker';
import { getJwt } from '@app/helpers';
import Axios from 'axios';

export interface RelatorioControleQaQc {
  id: string;
  medicaoId: string;
  contratoId: string;
  numeroBm: number;
  numeroContrato: number;
  periodoInicio: string;
  periodoFim: string;
  fornecedor: string;
  gestorMRN: string;
  admContrato: string;
  houveNaoConformidade: boolean;
  nivelConformidadeMedicao: string;
  createdAt: string;
  statusNome: string;
  modoGeracao: string;
  conformidadeTexto: string;
  identificadorPQ: string;
}

export const GetRelatorioControleQaQc = () => api.get<RelatorioControleQaQc[]>(`relatorios/resumoControleQaQc`);

export const relatorioControleQaQcExportarExcel = () => {
  let urlBase = window.location.origin;
  trackPromise(Axios.get(urlBase + `/api/relatorios/resumoControleQaQc/excel`,
    {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "relatorio_controleqaqc.xlsx");
      link.setAttribute('id', 'downloadrelatorio_controleqaqc');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadrelatorio_controleqaqc').outerHTML = '';
    }));
};
